const TYPE_CONTENT_ENUM = Object.freeze({
    URL: 2,
    FILE: 3,
});

export default TYPE_CONTENT_ENUM;